import PricePerUnit from "@/customizations/selgros/Fieldtypes/PricePerUnit.vue";
import PriceMwstCheckbox from "@/customizations/selgros/Fieldtypes/PriceMwstCheckbox.vue";
import ArticleNumberCheckbox from "@/customizations/selgros/Fieldtypes/ArticleNumberCheckbox.vue";
import ArticleTemplateSelect from "@/customizations/selgros/Fieldtypes/ArticleTemplateSelect.vue";
import SymbolCheckbox from "@/customizations/selgros/Fieldtypes/SymbolCheckbox.vue";
import BulletPointList from "@/customizations/selgros/Fieldtypes/BulletPointList.vue";
import MarketSelection from "@/customizations/selgros/Fieldtypes/MarketSelection.vue";
import TemplateFormat from "@/customizations/selgros/Fieldtypes/TemplateFormat.vue";
import CustomizableSelection from "@/customizations/selgros/Fieldtypes/CustomizableSelection.vue";
import Spacer from "@/customizations/selgros/Fieldtypes/Spacer.vue";
import CustomizableTable from "@/customizations/selgros/Fieldtypes/CustomizableTable.vue";

const calculateBruttoPrice = (nettoString, vatString) => {
    try {
        const netto = parseFloat(nettoString.replace(',', '.') * 1000);
        const vat = parseFloat(vatString);
        const brutto = Math.round((netto * (100 + vat)) / 1000);
        const result = (brutto / 100).toFixed(2);
        if (result <= 0.0 || isNaN(result)) {
            return "";
        }
        return result;
    } catch (error) {
        return "";
    }
}

const calculateUnitPrice = (nettoPrice, units) => {
    try {
        const netto = parseFloat(nettoPrice.replace(',', '.') * 10000);
        const unit = parseFloat(units);
        const unitPrice = Math.round(netto / unit);
        const rounded = Math.round(unitPrice / 10);
        const result = '' + (rounded / 1000).toFixed(3);

        //if the third decimal is 0, remove it
        const c = result.split('.');
        if (c.length === 2 && c[1].length === 3 && c[1].charAt(2) === '0') {
            return c[0] + '.' + c[1].charAt(0) + c[1].charAt(1);
        }

        if (result <= 0.0 || isNaN(result) || result === "Infinity") {
            return "";
        }
        return result;
    } catch (error) {
        return "";
    }
}

const onChangeProductFieldValue = (event) => {

    //event.product

    //calculate brutto price if netto price or vat changed
    if (event.fieldName === 'price' || event.fieldName === 'vat') {
        try {
        const price = event.productData.customFields['price'].value;
        const vat = event.productData.customFields['vat'].value;
        const brutto = calculateBruttoPrice(price, vat);
        event.changeProductFieldValue('price_with_vat', null, brutto);
        } catch (e) {
            console.error(e);
        }
    }

    if (event.fieldName === 'app_price' || event.fieldName === 'vat') {
        try {
            const price = event.productData.customFields['app_price'].value;
            const vat = event.productData.customFields['vat'].value;
            const brutto = calculateBruttoPrice(price, vat);
            event.changeProductFieldValue('app_price_with_vat', null, brutto);
        } catch (e) {
            console.error(e);
        }
    }

    if (event.fieldName === 'quantity' || event.fieldName === 'package_type' || event.fieldName === 'price') {
        try {
            const price = event.productData.customFields['price'].value;
            const quantity = event.productData.customFields['quantity'].value;
            let package_type = "" + event.productData.customFields['package_type'].value;

            const bottleTypes = ['MW-Flasche', 'Bügelflasche', 'PET-MW-Flasche', 'PET-EW-Flasche', 'EW-Flasche'];
            for (let i = 0; i < bottleTypes.length; i++) {
                if (package_type.toString() === bottleTypes[i].toString()) {
                    package_type = 'Flasche';
                }
            }

            const unitPrice = calculateUnitPrice(price, quantity);
            const value = unitPrice !== '' ? unitPrice + ' / ' + package_type : '';

            if (event.productData.customFields['price_per_unit'].value !== "") {
                event.changeProductFieldValue('price_per_unit', null, value);
            } else {
                //event.changeProductFieldValue('price_per_unit', null, "");
            }
        } catch (e) {
            console.error(e);
        }
    }


    if (event.fieldName === 'vat' || event.fieldName === 'app_price') {
        try {
            const price = event.productData.customFields['app_price'].value;
            const vat = event.productData.customFields['vat'].value;
            const brutto = calculateBruttoPrice(price, vat);
            event.changeProductFieldValue('app_price_with_vat', null, brutto);
        } catch (e) {
            console.error(e);
        }

    }

    if (event.fieldName === 'vat' || event.fieldName === 'pack_price') {
        try {
            const price = event.productData.customFields['pack_price'].value;
            const vat = event.productData.customFields['vat'].value;
            const brutto = calculateBruttoPrice(price, vat);
            event.changeProductFieldValue('pack_price_with_vat', null, brutto);
        } catch (e) {
            console.error(e);
        }
    }

    if (event.fieldName === 'vat' || event.fieldName === 'bundle_price') {
        try {
            const price = event.productData.customFields['bundle_price'].value;
            const vat = event.productData.customFields['vat'].value;
            const brutto = calculateBruttoPrice(price, vat);
            event.changeProductFieldValue('bundle_price_with_vat', null, brutto);
        } catch (e) {
            console.error(e);
        }
    }


}

const init = (sys) => {
    sys.addHook('onChangeProductFieldValue', onChangeProductFieldValue);
};

export default {
    fieldTypes: {
        PricePerUnit,
        PriceMwstCheckbox,
        ArticleNumberCheckbox,
        ArticleTemplateSelect,
        SymbolCheckbox,
        BulletPointList,
        MarketSelection,
        TemplateFormat,
        CustomizableSelection,
        CustomizableTable,
        Spacer
    },
    init,
};